// extracted by mini-css-extract-plugin
export var orderSummary = "_k2-0";
export var showMoreLessButton = "_k2-1";